import Paginator from "./PaginatorFixed";
import {useTranslation} from "react-i18next";
/**
 * Componente paginador e informacion paginacion
 * @param {Object} pagerModel - Modelo de paginación con paging y handleCallApi
 * @param {string} [stickyTopValue] - Valor para el estilo 'top'
 */
const TopBarPagination = ({pagerModel, size = 12}) => {
    const {t: _Tf} = useTranslation("forms");
    if (!pagerModel || !pagerModel.active) {
        return <div className="text-center">...</div>;
    }

    const {count, start, end} = pagerModel.paging;

    return (
        <div className="row py-2 bg-transparent">
            <div className="d-flex justify-content-center align-items-center">
                <div className="me-3 d-flex align-items-center">
                    Total: {count}&nbsp;&nbsp; | &nbsp;&nbsp;{start + 1} - {Math.min(end, count)}
                </div>
                <Paginator paging={pagerModel.paging} handleCallApi={pagerModel.handleCallApi} size={size} />
            </div>
        </div>
    );
};

export default TopBarPagination;
